import { useViewEvent, useViewerListener } from '@tymely/services';

import useGetTemplateTopic from './useGetTemplateTopic';

const TEMPLATE_VIEW_EVENT = 'TEMPLATE_BEING_PROCESSED';

export const useTemplateViewEvent = () => {
    const topic = useGetTemplateTopic();
    useViewEvent(topic, TEMPLATE_VIEW_EVENT);
};

export const useTemplateViewListener = () => {
    const topic = useGetTemplateTopic();
    return useViewerListener(topic, TEMPLATE_VIEW_EVENT);
};
